/**
 * Search functionality.
 */



/**
 * Module imports.
 */
import { ErrorHandler } from 'errorhandler/errorhandler.js';
import { i18n, __ } from "i18n/i18n.js";
import { MDCTextField } from "@material/textfield/dist/mdc.textfield.min.js";
import { log } from 'util';



/**
 * Module constants
 */
export const SEARCH_OVERLAY_FADE_TIME = 300;



/**
 * Search class for the header.
 *
 * @class      Search (name)
 */
export class Search
{
	/**
	 * Adds the necessary event listeners.
	 */
	static addListeners()
	{
		// No touching until DOM is ready
		$( document ).on(
			'ready',
			function()
			{
				// Listen for clicks on the search button
				$( '.search-button__button' ).on(
					'click',
					function()
					{
						// Instantiate current class
						let Instance = new Search();

						// Set elements to member variables
						Instance.$showOverlayButton = $( this );

						// Show the overlay
						Instance.showSearchOverlay();
					}
				);
			}
		);
	}



	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Member variables
		this.$showOverlayButton;
		this.$searchOverlay;
		this.$textField;
		this.$closeButton;
	}



	/**
	 * Renders the search overlay.
	 */
	renderSearchOverlay()
	{
		// Render the overlay at the end of body
		document.body.insertAdjacentHTML(
			'beforeend',
			`
				<div id="search-overlay" style="transition: opacity ${ SEARCH_OVERLAY_FADE_TIME }ms;">

					<form class="search-overlay__wrapper" action="${ __( 'searchURL', 'wisesite' ) }" method="GET">
						<div
						 class="mdc-text-field mdc-text-field--with-trailing-icon"
						>
							<input
							 name="s"
							 type="text"
							 class="mdc-text-field__input"
							 id="search-overlay__search-field"
							>
							<label
							 class="mdc-text-field__label"
							 for="search-overlay__search-field"
							>
								${ __( 'searchFieldLabel', 'wisesite' ) }
							</label>
							<button
							 type="submit"
							 class="search-overlay__submit-button mdc-text-field__icon"
							 tabindex="0"
							>
								<svg width="18px" height="16px" viewBox="0 0 18 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1294.000000, -47.000000)" stroke-linecap="round" stroke-linejoin="round">
										<g transform="translate(1296.000000, 49.000000)" stroke="#ffffff">
											<g>
												<path d="M10.3478261,4.8 C10.3478261,7.45086723 8.03167607,9.6 5.17391304,9.6 C2.3165471,9.6 0,7.45086723 0,4.8 C0,2.14913277 2.3165471,0 5.17391304,0 C8.03167607,0 10.3478261,2.14913277 10.3478261,4.8 Z" id="Stroke-1" stroke-width="2.5"></path>
												<path d="M8.82608696,8.21158879 L14,12" id="Stroke-3" stroke-width="2.5"></path>
											</g>
										</g>
									</g>
								</svg>
							</button>
							<div class="mdc-line-ripple"></div>
						</div>
					</form>

					<button type="button" class="search-overlay__close-button">
						<svg role="presentation" aria-hidden="true" width="28px" height="14px" viewBox="0 0 28 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-10.000000, -12.000000)">
								<g id="close" transform="translate(10.000000, 12.000000)">
									<path d="M9.93548387,4.375 L18.0645161,12.25" id="Line" stroke="#ffffff" stroke-width="1.134" stroke-linecap="round" stroke-linejoin="round"></path>
									<path d="M9.93548387,12.25 L18.0645161,4.375" id="Line-401" stroke="#ffffff" stroke-width="1.134" stroke-linecap="round" stroke-linejoin="round"></path>
								</g>
							</g>
						</svg>
					</button>
				</div>
			`
		);
	}



	/**
	 * Shows the search overlay.
	 */
	showSearchOverlay()
	{
		// Render the overlay
		this.renderSearchOverlay();

		// Set member variables with element references
		this.$searchOverlay = $( '#search-overlay' );
		this.$textField     = this.$searchOverlay.find( '.mdc-text-field' );
		this.$closeButton   = this.$searchOverlay.find( '.search-overlay__close-button' );

		// Instantiate the text field
		new MDCTextField( this.$textField[ 0 ] );

		// Push to the bottom of the callstack to make sure we don't add it before it gets a chance to render
		setTimeout(
			() =>
			{
				// Add the class that sets the styling
				this.$searchOverlay.addClass( 'solid' );
			},
			0
		);

		// When fade is done
		setTimeout(
			() =>
			{
				// Focus into the search field
				this.$textField.find( '.mdc-text-field__input' ).focus();
			},
			SEARCH_OVERLAY_FADE_TIME
		);

		// Listen for clicks on the close button
		this.$closeButton.on(
			'click',
			() =>
			{
				// Close the overlay
				this.closeOverlay();
			}
		);
	}



	/**
	 * Closes the search overlay.
	 */
	closeOverlay()
	{
		// Remove the class that sets the styling
		this.$searchOverlay.removeClass( 'solid' );

		// Wait half a second
		setTimeout(
			() =>
			{
				// Remove it entirely
				this.$searchOverlay.remove();
			},
			( SEARCH_OVERLAY_FADE_TIME + 50 )
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/modules/header/search.js